import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const routeTitles = {
  "/": "Home | The Pilot Guide",
  "/about": "About | The Pilot Guide",
  "/contact": "Contact | The Pilot Guide",
  "/login": "Login | The Pilot Guide",
  "/signup": "Sign Up | The Pilot Guide",
  "/dashboard": "Dashboard | The Pilot Guide",
};

const TitleManager = () => {
  const location = useLocation();

  useEffect(() => {
    const title = routeTitles[location.pathname] || "The Pilot Guide";
    document.title = title;
  }, [location.pathname]);

  return null;
};

export default TitleManager;
